import { createContext } from "react";

export const AuthContext = createContext({
    authData: {username: null, token: null, role: null},
    setAuthData: (authData) => {},
});